import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { FormRadioGroup } from '@monorepo/react-components';
import { NyseFormProps } from '../nyse-modal-content';

const NyseStepSeven: FunctionComponent<NyseFormProps> = ({ form }) => {
  const { t } = useTranslation(['contractModal', 'common']);
  return (
    <div className={'contracts-steps-body'}>
      <div>
        <div>
          <div>
            <p>{t('contractModal:nyse_modal.investment_advice_question')}</p>
            <FormRadioGroup
              form={form}
              controllerProps={{ name: 'investmentAdvices' }}
              options={[
                {
                  value: false,
                  text: t('common:no'),
                },
                {
                  value: true,
                  text: t('common:yes'),
                },
              ]}
            />
            <div>
              <p>{t('contractModal:nyse_modal.asset_manager_question')}</p>
              <FormRadioGroup
                form={form}
                controllerProps={{ name: 'assetManager' }}
                options={[
                  {
                    value: false,
                    text: t('common:no'),
                  },
                  {
                    value: true,
                    text: t('common:yes'),
                  },
                ]}
              />
            </div>
            <div>
              <p>{t('contractModal:nyse_modal.capital_usage_question')}</p>
              <FormRadioGroup
                form={form}
                controllerProps={{ name: 'usingOtherCapital' }}
                options={[
                  {
                    value: false,
                    text: t('common:no'),
                  },
                  {
                    value: true,
                    text: t('common:yes'),
                  },
                ]}
              />
            </div>
          </div>
          <div>
            <p>{t('contractModal:nyse_modal.entity_trading_question')}</p>
            <FormRadioGroup
              form={form}
              controllerProps={{ name: 'tradeForOtherCorpOrOther' }}
              options={[
                {
                  value: false,
                  text: t('common:no'),
                },
                {
                  value: true,
                  text: t('common:yes'),
                },
              ]}
            />
          </div>
          <div>
            <p>{t('contractModal:nyse_modal.profit_sharing_question')}</p>
            <FormRadioGroup
              form={form}
              controllerProps={{ name: 'sharingProfit' }}
              options={[
                {
                  value: false,
                  text: t('common:no'),
                },
                {
                  value: true,
                  text: t('common:yes'),
                },
              ]}
            />
          </div>
          <div>
            <p>
              {t('contractModal:nyse_modal.office_space_benefits_question')}
            </p>
            <FormRadioGroup
              form={form}
              controllerProps={{ name: 'sharingSpace' }}
              options={[
                {
                  value: false,
                  text: t('common:no'),
                },
                {
                  value: true,
                  text: t('common:yes'),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NyseStepSeven;
